export default function initTeamVideo() {
    const sections = document.querySelectorAll('.team-video');
    if (!sections.length) return;

    const hasGSAP = typeof window !== 'undefined'
        && window.gsap && window.gsap.core && window.ScrollTrigger;

    sections.forEach(sec => setupForSection(sec, hasGSAP));
}

function setupForSection(sec, hasGSAP) {
    const video = sec.querySelector('.team-video__el');
    if (!video) return;

    // створимо кнопку, якщо раптом видалили з розмітки
    let btn = sec.querySelector('.team-video__toggle');
    if (!btn) {
        btn = document.createElement('button');
        btn.className = 'team-video__toggle is-paused';
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Play video');
        btn.innerHTML = `
      <svg class="ico ico--pause" width="28" height="28" viewBox="0 0 28 28"><path fill="none" stroke="#fff" stroke-width="2" d="M10 7 v14 M18 7 v14"/></svg>
      <svg class="ico ico--play"  width="28" height="28" viewBox="0 0 28 28"><path fill="none" stroke="#fff" stroke-width="2" d="M10 7 L21 14 L10 21 Z"/></svg>
    `;
        sec.querySelector('.video-wrap')?.appendChild(btn);
    }

    // мобільний/автоплей-сейф
    video.muted = true;
    video.playsInline = true; // iOS
    // за замовчуванням не показуємо нативні контролли — кнопка є
    video.controls = false;

    const play = () => {
        // якщо користувач вручну поставив паузу — поважаємо вибір
        if (userPaused) return;
        const p = video.play();
        if (p && typeof p.catch === 'function') {
            p.catch(() => {/* ignore autoplay rejection */});
        }
        btn.classList.remove('is-paused');
        btn.setAttribute('aria-label', 'Pause video');
    };

    const pause = () => {
        if (!video.paused) video.pause();
        btn.classList.add('is-paused');
        btn.setAttribute('aria-label', 'Play video');
    };

    let userPaused = false;
    btn.addEventListener('click', () => {
        if (video.paused) {
            userPaused = false;
            play();
        } else {
            userPaused = true;
            pause();
        }
    });

    // ————— Scroll logic —————
    if (hasGSAP) {
        // start: коли top секції доходить до ~95% висоти вікна (майже низ)
        window.ScrollTrigger.create({
            trigger: sec,
            start: 'top 95%',
            end: 'bottom top',
            onEnter: play,
            onEnterBack: play,
            onLeave: pause,
            onLeaveBack: pause,
            // щоб підхоплювати ресайзи/шрифти
            invalidateOnRefresh: true
        });
    } else {
        // Fallback на IntersectionObserver
        const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
                // вважаємо "в полі" коли верх секції близько до низу екрану
                if (e.isIntersecting) {
                    play();
                } else {
                    pause();
                }
            });
        }, {
            // коли верх секції з’являється в нижніх 5% в’юпорту
            root: null,
            rootMargin: '0px 0px -5% 0px',
            threshold: 0
        });
        io.observe(sec);
    }

    // Безпека: пауза при приховуванні сторінки / втраті вкладки
    document.addEventListener('visibilitychange', () => {
        if (document.hidden) pause();
    });
}
